import { getRevenueCenterMenuUuids } from 'utils/menusDrawer/getRevenueCenterMenuUuids'
import { removeRevenueCenterUuid } from 'utils/menusDrawer/removeRevenueCenterUuid'
import { addRevenueCenterUuid } from 'utils/menusDrawer/addRevenueCenterUuid'
import { isEmpty, uniq } from 'lodash'

export const onChangeCheckbox = (
  uuid,
  parentUuid = null,
  filteredMenusAndRevenueCenters,
  selectedRevenueCentersAndMenusUuids,
  setSelectedRevenueCentersAndMenusUuids
) => {
  if (isEmpty(uuid)) {
    return setSelectedRevenueCentersAndMenusUuids(
      selectedRevenueCentersAndMenusUuids
    )
  }

  // if it is revenue center (parent) we have to add or remove all his children uuids
  if (parentUuid === null) {
    // uuids of menus assigned to revenue center
    const revenueCenterMenusUuids = getRevenueCenterMenuUuids(
      filteredMenusAndRevenueCenters,
      uuid
    )

    if (selectedRevenueCentersAndMenusUuids?.includes(uuid)) {
      // array of revenue center uuid and his menus uuids
      const uuidsToRemove = [uuid, ...revenueCenterMenusUuids]

      const newSelectedUuids =
        selectedRevenueCentersAndMenusUuids?.filter(
          (selectedUuid) => !uuidsToRemove?.includes(selectedUuid)
        )

      // remove parent uuid and also all his children uuids
      return setSelectedRevenueCentersAndMenusUuids(newSelectedUuids)
    } else {
      // add parent uuid and also his children uuids, when there is some of children uuids
      // then we will create uniqe array
      const uniqeNewSelectedUuids = uniq([
        ...selectedRevenueCentersAndMenusUuids,
        uuid,
        ...revenueCenterMenusUuids,
      ])

      return setSelectedRevenueCentersAndMenusUuids(
        uniqeNewSelectedUuids
      )
    }
  } else {
    if (selectedRevenueCentersAndMenusUuids?.includes(uuid)) {
      // newSelectedUuids is an array of uuids with current unchecked checkbox uuid
      const newSelectedUuids =
        selectedRevenueCentersAndMenusUuids?.filter(
          (selectedUuid) => selectedUuid !== uuid
        )

      // we have to check if we uncheck one of all checked menus, if so we have to return
      // revenue center uuid to be removed from all selectedRevenueCentersAndMenusUuids
      const revenueCenterUuidToRemove = removeRevenueCenterUuid(
        parentUuid,
        newSelectedUuids,
        filteredMenusAndRevenueCenters
      )

      // if revenueCenterUuidToRemove return uuid we have to
      // create new array of uuids to update without particular revenue center uuid
      const newSelectedUuidsWithoutRevenueCenterUuid =
        newSelectedUuids?.filter(
          (selectedUuid) => selectedUuid !== parentUuid
        )

      revenueCenterUuidToRemove === null
        ? setSelectedRevenueCentersAndMenusUuids(newSelectedUuids)
        : setSelectedRevenueCentersAndMenusUuids(
            newSelectedUuidsWithoutRevenueCenterUuid
          )
    } else {
      // we have to check if we check the last menu checkbox, if so we have to return
      // revenue center uuid to add to all selectedRevenueCentersAndMenusUuids
      const revenueCenterUuidToAdd = addRevenueCenterUuid(
        parentUuid,
        [...selectedRevenueCentersAndMenusUuids, uuid],
        filteredMenusAndRevenueCenters
      )

      revenueCenterUuidToAdd === null
        ? setSelectedRevenueCentersAndMenusUuids([
            ...selectedRevenueCentersAndMenusUuids,
            uuid,
          ])
        : setSelectedRevenueCentersAndMenusUuids([
            ...selectedRevenueCentersAndMenusUuids,
            uuid,
            parentUuid,
          ])
    }
  }
}
